/**
 * Работа с буфером обмена и drag&drop — извлечение изображений.
 */

/** Извлечь File изображения из события paste. null, если изображения нет. */
export function imageFromPasteEvent(e: ClipboardEvent): File | null {
  const items = e.clipboardData?.items;
  if (!items) return null;
  for (const item of items) {
    if (item.kind === 'file' && item.type.startsWith('image/')) {
      return item.getAsFile();
    }
  }
  return null;
}

/** Извлечь File изображения из события drag&drop. */
export function imageFromDropEvent(e: DragEvent): File | null {
  const dt = e.dataTransfer;
  if (!dt) return null;
  // 1) прямой файл
  if (dt.files && dt.files.length > 0) {
    const f = Array.from(dt.files).find((f) => f.type.startsWith('image/'));
    if (f) return f;
  }
  return null;
}

/** Глобально слушать Ctrl+V и колбэчить с File, если в буфере картинка. */
export function attachPasteHandler(onImage: (file: File) => void): () => void {
  const handler = (e: ClipboardEvent) => {
    // не перехватываем paste в поля ввода (редактирование текста)
    const target = e.target as HTMLElement | null;
    if (target && (target.isContentEditable || ['INPUT', 'TEXTAREA'].includes(target.tagName))) {
      return;
    }
    const file = imageFromPasteEvent(e);
    if (file) {
      e.preventDefault();
      onImage(file);
    }
  };
  window.addEventListener('paste', handler);
  return () => window.removeEventListener('paste', handler);
}
